export interface ServiceStatus {
  id: string;
  service_name: string;
  status: 'operational' | 'degraded' | 'outage' | 'maintenance';
  message: string | null;
  is_current: boolean;
  created_at: string;
  updated_at: string;
}

export interface MaintenanceWindow {
  id: string;
  title: string;
  description: string;
  start_time: string;
  end_time: string;
  affected_services: string[];
  status: 'scheduled' | 'in_progress' | 'completed' | 'cancelled';
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export interface MaintenanceForm {
  title: string;
  description: string;
  duration_hours: string;
  services: string[];
}

export interface ScheduleForm {
  title: string;
  description: string;
  start_date: string;
  start_time: string;
  duration_hours: string;
  services: string[];
  is_published: boolean;
}

export const SERVICES = ['database', 'api', 'auth', 'storage', 'app'] as const;

export const STATUS_OPTIONS: { value: ServiceStatus['status']; label: string; color: string; icon: string; defaultMessage: string }[] = [
  { value: 'operational', label: 'Operational', color: '#10b981', icon: '✅', defaultMessage: 'All services running normally' },
  { value: 'degraded', label: 'Degraded', color: '#f59e0b', icon: '⚠️', defaultMessage: 'Experiencing intermittent issues' },
  { value: 'outage', label: 'Outage', color: '#ef4444', icon: '❌', defaultMessage: 'Service is currently unavailable' },
  { value: 'maintenance', label: 'Maintenance', color: '#3b82f6', icon: '🔧', defaultMessage: 'Scheduled maintenance in progress' },
];

export const WINDOW_STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  scheduled: { bg: 'rgba(59,130,246,0.2)', text: '#3b82f6' },
  in_progress: { bg: 'rgba(245,158,11,0.2)', text: '#f59e0b' },
  completed: { bg: 'rgba(16,185,129,0.2)', text: '#10b981' },
  cancelled: { bg: 'rgba(107,114,128,0.2)', text: '#6b7280' },
};

export const EMPTY_FORM: MaintenanceForm = {
  title: '',
  description: '',
  duration_hours: '2',
  services: [...SERVICES],
};

export const EMPTY_SCHEDULE: ScheduleForm = {
  title: '', description: '', start_date: '', start_time: '', duration_hours: '2',
  services: [...SERVICES] as string[], is_published: true,
};
